import { Box, Typography, useTheme } from "@mui/material";
import { PropertyPrice } from "../../../types";
import EditPriceInfo from "./edit-price-info";
import PropertyPriceData from "./property-price-data";

export default function PropertyPriceInfo({
  propertyUId,
  propertyPrice,
  trackUid,
  title,
}: {
  propertyUId: string;
  trackUid: string;
  propertyPrice: PropertyPrice;
  title?: string;
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        width: "100%",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={theme.nawy.typography.english.variants.body.md.semibold}
          >
            {title ?? propertyPrice.priceRole}
          </Typography>
          <EditPriceInfo
            propertyUId={propertyUId}
            trackUid={trackUid}
            propertyPrice={propertyPrice}
          />
        </Box>

        <PropertyPriceData propertyPrice={propertyPrice} />
      </Box>
    </Box>
  );
}
